const hostname = window && window.location && window.location.hostname;

export const inDev = hostname === "localhost";

let backendHost;

if (inDev) {
  backendHost = "http://localhost:8080";
} else {
  backendHost = "https://r85tr312u6.execute-api.us-west-2.amazonaws.com/Public";
}

let liveviewURL;
if (inDev) {
  liveviewURL = "ws://localhost:8090";
} else {
  liveviewURL = "wss://ovaukw1wwk.execute-api.us-west-2.amazonaws.com/Public";
}
export const LIVEVIEW_URL = liveviewURL;

export const API_ROOT = `${backendHost}`;

let dsn;
if (inDev) {
  dsn = "https://8c749c95ea7e4b329e997e8a8be3377a@sentry.io/1863683";
} else {
  dsn = "https://760df276e8d149848b20d62292c0b396@sentry.io/1863680";
}

export const DSN = dsn;
